import React from "react";

import DescriptionListItem from "./DescriptionListItem";
import DescriptionListButtonItem from "./DescriptionListButtonItem";
import DescriptionListCodeBlockItem from "./DescriptionListCodeBlockItem";

type DescriptionListProps = {
  type?: "default" | "danger";
  title?: string;
  description?: string;
  children?: React.ReactNode;
};
const DescriptionList = ({ type = "default", title, description, children }: DescriptionListProps) => {
  return (
    <div>
      {title && <div className="text-xl font-semibold text-notblack">{title}</div>}
      {description && <div className="text-base text-smoke">{description}</div>}
      <dl
        className={`${
          type === "danger" ? "divide-red-300 border-red-300" : "divide-gray-200 border-gray-200"
        } divide-y`}
      >
        {children}
      </dl>
    </div>
  );
};

export default Object.assign(DescriptionList, {
  Item: DescriptionListItem,
  ButtonItem: DescriptionListButtonItem,
  CodeBlockItem: DescriptionListCodeBlockItem,
});
